import { Answer } from './Answer';
export class Solution {
  static fromItem(item) {
    return new Solution(item.solution.answer);
  }
  constructor(value) {
    this.value = value;
  }
  toString() {
    return this.value;
  }
  asAnswer() {
    return new Answer(this.value);
  }
}